import {
  BarChart3,
  FileText,
  Briefcase,
  Receipt,
  Truck,
  Users,
  Building2,
  Shield,
} from "lucide-react";
import { useUserMenu } from "ra-core";
import { Link } from "react-router";
import { DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export function BldrOsMenuItems() {
  const userMenuContext = useUserMenu();
  if (!userMenuContext) {
    throw new Error("<BldrOsMenuItems> must be used inside <UserMenu>");
  }

  const Item = ({
    to,
    icon: Icon,
    label,
  }: {
    to: string;
    icon: React.ComponentType<any>;
    label: string;
  }) => (
    <DropdownMenuItem asChild onClick={userMenuContext.onClose}>
      <Link to={to} className="flex items-center gap-2">
        <Icon className="size-4" />
        {label}
      </Link>
    </DropdownMenuItem>
  );

  return (
    <>
      <DropdownMenuSeparator />
      <Item to="/pipeline" icon={BarChart3} label="Pipeline" />
      <Item to="/estimates" icon={FileText} label="Estimates" />
      <Item to="/jobs" icon={Briefcase} label="Jobs" />
      <Item to="/invoices" icon={Receipt} label="Invoices" />
      <Item to="/vendors" icon={Truck} label="Vendors" />
      <Item to="/subcontractors" icon={Users} label="Subcontractors" />
      <Item to="/org-settings" icon={Building2} label="Org Settings" />
      <Item to="/super-admin" icon={Shield} label="Super Admin" />
    </>
  );
}
